import { useEffect } from "react";
import { getUserCustomer } from "../../../../services/Api/customerService";
import { usePartnerHomeCustomerStore } from "../../../../stores/Cac/Partner/partnerHomeCustomer";
import { getCustomerData } from "../../../../services/Cac/functionToUpdate";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import {
  createCustomerByIdPartner,
  getUserPartnerByIdCollab,
  updateCustomerByIdPartner,
} from "../../../../services/Api/partnerService";
import { useParams } from "react-router-dom";
import { useTokenContext } from "../../../../context/tokenContext";

const PartnerModalCreateUpdateCustomer = () => {
  const { idPartner } = useParams();
  const { userId } = useTokenContext();
  // Store
  const {
    choiceModal,
    setChoiceModal,
    setPartners,
    name,
    setName,
    setCheckboxValues,
    idCustomer,
    setIdCustomer,
    setPartnersAssigned,
    customersAssigned,
    setCustomersAssigned,
  } = usePartnerHomeCustomerStore();

  const handleReset = () => {
    setName("");
    setCheckboxValues({});
    setPartnersAssigned([]);
    setCustomersAssigned([]);
    setIdCustomer(0);
    setChoiceModal("");
  };

  // Get all users partners
  useEffect(() => {
    if (idPartner) {
      getUserPartnerByIdCollab(Number(idPartner))
        .then((data) => {
          // Filter the user connected
          const users = data.filter((user: any) => user.id !== userId);
          setPartners(users);
        })
        .catch(() => showToastError("Une erreur s'est produite"));
      }
  }, []);

  const handleCreateOrUpdateClientFile = async () => {
    if (name === "") {
      showToastError("Votre client est mal renseigné !");
    } else if (name.length >= 30) {
      showToastError(
        "Le nom du client est trop long ne doit pas dépasser 30 caractères."
      );
    } else {
      try {
        if (idPartner) {
          if (choiceModal === "create") {
            const dataForSend = {
              name: name,
              existingCustomerUsers: [],
            };
            const idClient = await createCustomerByIdPartner(
              dataForSend,
              Number(idPartner)
            );
            if (idClient) {
              handleReset();
              setCheckboxValues({});
              showToastSuccess("Votre dossier à bien été créée !");
            }
          } else {
            const dataForUpdate = {
              name: name,
              existingCustomerUsers: customersAssigned?.map((user) => user.id),
            };

            const response = await updateCustomerByIdPartner(
              dataForUpdate,
              Number(idPartner),
              idCustomer
            );
            if (response) {
              handleReset();
              setCheckboxValues({});
              showToastSuccess("Votre modification à bien été effectuée !");
            }
          }
        }
      } catch (error) {
        if((error as any)?.response?.data?.message === "Customer already exists") {
          showToastError("Nom de dossier déja utilisé sur un dossier");
        } else if((error as any)?.response?.data?.message === "Customer already exists but closed"){
          showToastError("Nom de dossier déja utilisé sur un dossier archivé");
        } else {
          showToastError("Une erreur est survenue !");
        }
      }
    }
  };

  // Update //
  // Function to get the data of a client with collaborators assigned
  useEffect(() => {
    if (idCustomer === 0 || choiceModal === "create") return;
    const fetchData = async () => {
      try {
        const { clientName, checkboxValues } =
          await getCustomerData(idCustomer);
        setName(clientName);
        setCheckboxValues(checkboxValues);
      } catch (error) {
        showToastError("Une erreur est survenue !");
      }
    };

    const fetchCustomerAssigned = async () => {
      try {
        const usersCustomer = await getUserCustomer(idCustomer);
        setCustomersAssigned(usersCustomer);
      } catch (error) {
        showToastError("Une erreur est survenue !");
      }
    };

    fetchCustomerAssigned();
    fetchData();
  }, [idCustomer, choiceModal]);

  return (
    choiceModal !== "" && (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-3 outline-hidden focus:outline-hidden sm:p-6">
          <div className="relative mx-auto w-full max-w-2xl">
            {/*content*/}
            <div className="relative flex max-h-[calc(100dvh-1.5rem)] w-full flex-col overflow-hidden rounded-2xl border-0 bg-white shadow-2xl outline-hidden focus:outline-hidden sm:max-h-[calc(100dvh-3rem)]">
              {/*header*/}
              <div className="w-full flex-shrink-0 rounded-t-xl bg-white p-4">
                <h4 className="flex items-center gap-2 text-lg font-semibold text-gray-700 sm:text-xl">
                  <svg className="w-5 h-6 text-yellow-trio" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  {choiceModal === "create" ? "Créer un dossier client" : "Modifier le dossier client"}
                </h4>
              </div>
              {/*body*/}
              <div className="flex min-h-0 w-full flex-col items-center overflow-y-auto px-4 text-grey-trio sm:px-5">
                <div className="mb-2 flex w-full flex-col items-start justify-start">
                  <label
                    htmlFor="name"
                    className="text-md sm:text-lg my-2"
                  >
                    Nom du dossier client :
                  </label>
                  <input
                    type="text"
                    value={name}
                    className="mb-4 h-11 w-full rounded-xl border border-gray-300 px-3 shadow-sm focus:border-yellow-trio focus:outline-none focus:ring-2 focus:ring-yellow-trio/30 sm:max-w-sm"
                    onChange={(e) => setName(e.target.value)}
                    minLength={10}
                    maxLength={200}
                    name="name"
                    id="name"
                    placeholder="Nom du client"
                    required
                  />
                </div>        
                {choiceModal === "update" ? (
                  <div className="flex w-full flex-col text-base sm:text-lg">
                    <label htmlFor="name" className="text-lg mb-2 my-4">
                      Clients affectés :
                    </label>

                    {customersAssigned?.length > 0 ? (
                        <div className="mt-2 h-52 w-full overflow-auto">
                         <div className="min-w-[32rem] overflow-hidden rounded-lg border border-gray-300 shadow-sm">
                           <table className="w-full border-collapse">
                             <thead className="sticky top-0">
                               <tr className="bg-dark-lavender text-white">
                                 <th className="px-3 py-2 text-left text-sm font-medium">
                                   Nom
                                 </th>
                                 <th className="px-3 py-2 text-left text-sm font-medium">
                                   Prénom
                                 </th>
                                 <th className="px-3 py-2 text-left text-sm font-medium">
                                   Email
                                 </th>
                                 <th className="px-3 py-2 text-left text-sm font-medium">
                                   Statut
                                 </th>
                               </tr>
                             </thead>
                             <tbody>
                               {customersAssigned?.map((user, index) => (
                                 <tr key={user?.id} className="hover:bg-gray-50 border-b border-gray-200 last:border-b-0 max-h-36 overscroll-y-auto">
                                   <td className="px-3 py-2 text-sm">
                                     {user.firstName === "" ? "-" : user.firstName}
                                   </td>
                                   <td className="px-3 py-2 text-sm">
                                     {user.firstName === "" ? "-" : user.lastName}
                                   </td>
                                   <td className="px-3 py-2 text-sm">
                                     {user.eMail}
                                   </td>
                                   <td className="px-3 py-2 text-sm">
                                     {user.lastConnection === null ? (
                                       <span className="text-orange-600 italic text-xs">
                                         Compte non créé
                                       </span>
                                     ) : (
                                       <span className="text-green-600 text-xs">
                                         Compte actif
                                       </span>
                                     )}
                                   </td>
                                 </tr>
                               ))}
                             </tbody>
                           </table>
                         </div>
                       </div>
                    ) : (
                      <p className="w-full text-center text-sm py-4 italic">
                        Aucun client affecté
                      </p>
                    )}
                  </div>
                ) : null}
              </div>
              {/*footer*/}
              <div className="flex flex-shrink-0 items-center justify-end gap-3 rounded-b-2xl bg-white p-3">
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-500 transition-all duration-200 hover:bg-red-500 hover:text-white sm:flex-none"
                  type="button"
                  onClick={() => {
                    handleReset();
                  }}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                {choiceModal === "create" ? (
                  <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-green-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                  type="button"
                    onClick={() => handleCreateOrUpdateClientFile()}
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.586a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Créer
                  </button>
                ) : (
                  <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-green-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                  type="button"
                    onClick={() => handleCreateOrUpdateClientFile()}
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.586a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Modifier
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default PartnerModalCreateUpdateCustomer;
